import React from 'react';

import Image from 'react-bulma-companion/lib/Image';

import zev from "_assets/images/Zev.jpeg"


export default function SubInfo({ message, className = '' }) {
    const parseSubInfo = (text) =>
        /** newlines */
        text.split('\n').map((s, index) => <span key={index}>{
            /** bold */
            s.split(/(<b>|<\/b>)/).filter((item, index) => index % 2 === 0).map((bold, index) => {
                /** rest */
                let next = bold;
                return <span key={index}>{index % 2 !== 0 ? <b>{next}</b> : <>{next}</>}</span>
            })
        }{index < s.length ? <br /> : ''}</span>);

    return (
        <div className={`sub-info ${className}`}>
            <Image size="32x32">
                <Image.Content className="sub-info-image" src={zev} alt="Zev" title="Zev" />
            </Image>
            <div className="message inbound">{parseSubInfo(message)}</div>
        </div>
    );
}